const isNullOrFalse = value => value === null || value === false;

export default isNullOrFalse;
